import { Vue, Component, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { sessionService } from '@/providers/services/auth/session';

@Component({
  name: 'impersonate-card',
  components: {
    'material-icon': GoogleMaterialIcon,
  },
})

export default class ImpersonateCard extends Vue {

  // -------------------------------------------------------------------------
  // Properties

  /**
   * Holding all the user roles data
   */
  private get superUser() {
    return sessionService.getDemoSessionCopy() || {};
  }

  private get impersontateUser() {
    return sessionService.getSession() || {};
  }

  /**
   *
   * Action trigger when click on any users
   */
  private onChangeRole() {
    const session = sessionService.getDemoSessionCopy();
    if (session) {
      this.$access.updateRole(session);
    }
  }

}
